module.exports = __webpack_public_path__ + "img/first.4c7f90ee.png";